import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { getLastPurchaseReturnDaybook } from '../redux/actions/purchaseReturnInvoice';
import moment from 'moment';

const usePurchaseReturnLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastPurchaseReturnDaybook = useSelector((state) => state.purchaseReturnInvoice?.lastDaybook);

   const getLastDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');

         const params = {
            companyId: user.loginhistory.companyId,
            fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastPurchaseReturnDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastDaybook();
   }, [getLastDaybook]);

   return { lastPurchaseReturnDaybook, setSelectedDaybookId };
};

export default usePurchaseReturnLastDaybook;
